import { render, staticRenderFns } from "./JoinsSettings.vue?vue&type=template&id=2327fba4&"
import script from "./JoinsSettings.vue?vue&type=script&lang=js&"
export * from "./JoinsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports